
import {Component, Prop, Vue} from "vue-property-decorator";
import DataFieldCache from "../../../models/data.field.cache";
import dataFieldTypes from "@/dataFieldTypes";
import {dataFieldsEditModule} from "@/store";
import {translate} from "@/auxillary/translation";

@Component({
  name: 'EventReportListField',
  components: {
    ...dataFieldTypes,
  },
})
export default class EventReportListField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  private editingEventId = "";

  get isVisible() {
    return this.dataField.isVisible ?? false;
  }

  get validationMessages() {
    return this.dataField?.id != null
        ? dataFieldsEditModule.validationMessages.filter(m => m.dataFieldId == this.dataField.id)
        : [];
  }

  translateMessage(displayKey: string, parameters?: { [key: string]: string }) {
    const translation = translate(displayKey, undefined, parameters);
    return translation != displayKey
        ? translation
        : "Dies ist eine Pflichtangabe. Bitte fügen Sie mindestens einen Eintrag hinzu.";  // TODO hacky way to have required field messages
  }

  get isEditable() {
    return this.dataField.isEditable;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }

  createNewListEntry() {
    dataFieldsEditModule.createChildField({
      parentField: this.dataField,
      temporaryFields: dataFieldsEditModule.temporaryFields,
      childFieldDefinitionId: undefined
    })

    // save temporary id of new child field and open field entry
    this.editingEventId = dataFieldsEditModule.lastAddedChildFieldId;
  }

  mounted() {
    this.editingEventId = dataFieldsEditModule.lastEditedFieldId;
  }

  handleSaveEntry(entryId: string) {
    this.editingEventId = entryId;
    dataFieldsEditModule.setLastEditedFieldId(entryId);
    // eslint-disable-next-line no-undef
    // eventBus.$emit("reload-instrument"); // HIER
  }

  handleCancelEntry() {
    this.editingEventId = "";
    dataFieldsEditModule.setLastEditedFieldId(this.editingEventId);
    dataFieldsEditModule.setIsEditingAeReport(false);
    dataFieldsEditModule.setEditingAeReportId("");
  }

  handleStartEditing(entryId: string) {
    this.editingEventId = entryId;
    dataFieldsEditModule.setIsEditingAeReport(true);
    dataFieldsEditModule.setEditingAeReportId(entryId);
  }
}
